import { getEnv, getMockAddress } from "#/utils/getEnv";

export const APPLICATION = {
  ID: process.env.REACT_APP_ID.replace(/-/g, "_"),
  NAME: `@${process.env.REACT_APP_ID.replace(/-/g, "_").toUpperCase()}`,
  EXTERNAL: ["WEB_CRM", "WEB_PUBLIC"].includes(
    process.env.REACT_APP_JOB_TEMPLATE_TYPE
  ),
  get BFF_URL() {
    const env = getEnv();
    if (env === "mock") {
      return getMockAddress();
    }

    return window.env?.BFF_URL;
  },

  get BFF_URL_V2() {
    const env = getEnv();
    if (env === "mock") {
      return getMockAddress();
    }

    return window.env?.BFF_URL_V2;
  },

  get BFF_URL_SECCORP() {
    return window.env?.BFF_URL_SECCORP;
  },

  get ENV() {
    return window.env?.ENV;
  },
};

export const PAGE = {
  ROOT: () => "/",
  SOON: () => "/plataforma-de-viagens",
  HOME: () => "/home",
  MILESREDEMPTION: () => "/resgate-de-milhas",
  LIVELOREDEMPTION: () => "/transferencia-livelo",
  LIVELOSUCCESS: () => "/livelo-sucesso",
};

export const ERROR_MESSAGES = {
  FORBIDDEN: (action?: string) => ({
    title: "Acesso não autorizado.",
    children: `Você não possui permissão para realizar esse acesso.`,
    secondaryButton: undefined,
  }),
  UNAVAILABLE: (title?: string) => ({
    title: title ?? "Serviço indisponível.",
    children: `Estamos passando por instabilidades no sistema. Tente novamemte em alguns instantes.`,
  }),
  NOT_FOUND: (title?: string, children?: string) => ({
    title: title ?? "Registro não encontrado.",
    children: children ?? `Não identificamos o item solicitado.`,
  }),
  REQUIRED: () => "Campo obrigatório.",
};
